/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Mod_Rental_TitleInputs */

const es_faq_mod_rental_title = /** @type {(inputs: Faq_Mod_Rental_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Alquiler`)
};

const gl_faq_mod_rental_title = /** @type {(inputs: Faq_Mod_Rental_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Alugueiro`)
};

const en_faq_mod_rental_title = /** @type {(inputs: Faq_Mod_Rental_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Rental`)
};

/**
* | output |
* | --- |
* | "Zarpar Rental" |
*
* @param {Faq_Mod_Rental_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_mod_rental_title = /** @type {((inputs?: Faq_Mod_Rental_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Mod_Rental_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_faq_mod_rental_title(inputs)
	if (locale === "en") return en_faq_mod_rental_title(inputs)
	return es_faq_mod_rental_title(inputs)
});